import { Box, BoxProps } from '@mui/material';

interface IPageContainerProps extends BoxProps {
  disablePadding?: boolean;
}

// Padding/gap padrão de página (guia seção 27) — 24px desktop / 16px em
// telas menores, gap de 16px entre seções.
export const PageContainer: React.FC<IPageContainerProps> = ({ disablePadding = false, sx, children, ...rest }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        ...(disablePadding ? {} : { p: { xs: 2, sm: 3 } }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
